import $ from "jquery"
import debounce from "lodash/debounce"

$(document).on('turbolinks:load', () => {  
  const $formInputs = $('*[data-promotion-target="input"]');
  if ($formInputs.length > 0) {
    $formInputs.each(function() {
      if (this.tagName === "SELECT") {
        $(this).on("change", function() {
          $(this).closest('form').requestSubmit();
        });
      } else {
        $(this).on("input", debounce(function() {
          $(this).closest('form').requestSubmit();
        }, 500));
      }
    });
  }
  
  // Initialize tooltips
  $('[data-toggle="tooltip"]').tooltip();
  
  // Initialize select2 if available
  if ($.fn.select2) {
    $('.select2').select2({
      theme: 'bootstrap4',
      width: '100%'
    });
  }
}); 